import { EvaluationArtistModel, EvaluationLeaderModel } from "../../../../models/ExpertModels/Evaluation.model"
import { ReactComponent as VK } from '../../../../assets/icons/vk.svg'
import { ReactComponent as Instagram } from '../../../../assets/icons/instagram.svg'
import { ReactComponent as Tiktok } from '../../../../assets/icons/tiktok.svg'
import { ReactComponent as Youtube } from '../../../../assets/icons/youtube.svg'
import { ReactComponent as Telegram } from '../../../../assets/icons/telegram.svg'
import { ReactComponent as Rutube } from '../../../../assets/icons/rutube.svg'
import { ReactComponent as Max } from '../../../../assets/icons/max.svg'

interface ProjectInSocialDataItem {
  field: keyof EvaluationArtistModel;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const projectInSocialData: ProjectInSocialDataItem[] = [
  {
    field: 'instagramUrl',
    icon: Instagram
  },
  {
    field: 'vkontakteUrl',
    icon: VK
  },
  {
    field: 'tiktokUrl',
    icon: Tiktok
  },
  {
    field: 'youtubeUrl',
    icon: Youtube
  },
  {
    field: 'telegramUrl',
    icon: Telegram
  },
  {
    field: 'rutubeUrl',
    icon: Rutube
  },
  {
    field: 'maxUrl',
    icon: Max
  }
]

// export const musicSocialData: ProjectInSocialDataItem[] = [
//   {
//     field: 'musicVkontakteUrl',
//     icon: VK
//   },
//   {
//     field: 'musicSpotifyUrl',
//     icon: Spotify
//   },
//   {
//     field: 'musicSoundcloudUrl',
//     icon: Soundcloud
//   },
//   {
//     field: 'musicYandexUrl',
//     icon: YandexMusic
//   }
// ]

interface LeaderSocialDataItem {
  field: keyof EvaluationLeaderModel;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}

export const leaderSocial: LeaderSocialDataItem[] = [
  {
    field: 'instagramUrl',
    icon: Instagram
  },
  {
    field: 'vkontakteUrl',
    icon: VK
  },
  {
    field: 'tiktokUrl',
    icon: Tiktok
  },
  {
    field: 'youtubeUrl',
    icon: Youtube
  },
  {
    field: 'telegramUrl',
    icon: Telegram
  },
  {
    field: 'rutubeUrl',
    icon: Rutube
  },
  {
    field: 'maxUrl',
    icon: Max
  }
]
